import React from 'react';
import { useTranslation } from "react-i18next";

import { List, ListSubheader, Stack, Tooltip, Typography } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';

import SelectLocation from '../../SelectLocation';

export default function LocationSelectSection(props) {
    const { t } = useTranslation();
    const { disabled = false } = props;

    return (
        <List component="nav"
            aria-labelledby="subheader-location"
            subheader={
                <ListSubheader component="div" id="subheader-location" disableSticky={true}>
                    <Stack alignItems="center" direction="row" spacing={1}>
                        <Typography variant="headline" component="h5">{t("sidebar.location")}</Typography>
                        <PlaceIcon color="primary" />
                    </Stack>
                </ListSubheader>
            }>
            <Tooltip
                disableHoverListener={!disabled}
                disableFocusListener={!disabled}
                disableTouchListener={!disabled}
                placement="bottom-start"
                title={disabled ? t("sidebar.location.disabledCartTooltip") : ""}
                componentsProps={{
                    tooltip: {
                        sx: {
                            bgcolor: 'white',
                            color: 'black',
                            padding: '10px',
                            boxShadow: '0px 2px 4px rgba(0,0,0,0.2)'
                        }
                    }
                }}
            >
                <span style={{ display: "block" }}>
                    <SelectLocation sx={{ width: "100%" }} disabled={disabled} />
                </span>
            </Tooltip>
        </List>
    );
}
